import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadCoupons () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.filters,
      ...this.pagination.getParams(),
    })

    api.get('plan_coupons', { params })
      .then(result => {
        this.coupons = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  clearFilters () {
    this.filters = {}
    this.loadCoupons()
  },

  exportCoupons: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
        ...this.filters,
      },
    )

    api.get('plan_coupons/export', { params }, { responseType: 'blob' })
      .then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'export.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.log(error)
      })
  },
}
